import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CountryPhoneNumberCode, PhoneNumberInput} from '../kamona-input-field/kamona-input-field.component';
import {StringHelper} from '../../../core/helpers/strings.helper';
import { logger } from '@mpt-fo/common/telemetry';

@Component({
	selector: 'app-kamona-phone-number-field',
	templateUrl: './kamona-phone-number-field.component.html',
	styleUrls: ['./kamona-phone-number-field.component.scss'],
})
export class KamonaPhoneNumberFieldComponent implements OnInit {
	isPhoneNumberOnFocus: boolean;
	inputValue: any;
	label: string;
	@Input() input: any;
  @Input() PREFIX: any;
  @Input() updateNGPhoneNo: boolean = true;
	@Output() emitInput = new EventEmitter();
	readonly IS_VALID_INPUT = 'valid';
	readonly ERROR_CLASS = 'in-valid';
	placeHolder = ' ';
	validationError: boolean;
	id: string;
	validInput: boolean;
	isShowInputStateSuffix: boolean;
  readonly defaultMaxLength = 11;
  maxInputLength: number;

	constructor() {
	}

	ngOnInit(): void {
		this.input = this.input || this.initializeInput();
    this.maxInputLength = this.input?.maxLength || this.defaultMaxLength;
		this.isShowInputStateSuffix = this.input.isShowInputStateSuffix();
		this.label = this.input.getLabel();
		this.id = `kamona-phone-number-field-${this.input.getLabel()}`;
    this.inputValue = this.updateNGPhoneNo ? this.updateNGPhoneNumber(this.input.getInput(), this.input?.countryCode) : this.input.getInput();
		if (this.inputValue) {
			this.onInputChange(this.inputValue);
		}
	}

	updateNGPhoneNumber(phoneNo, countryCode) {
		if (countryCode === CountryPhoneNumberCode.NG) {
			const isNgPhoneNo = `${phoneNo}`.includes('234');
			phoneNo = isNgPhoneNo ? `${phoneNo}`.replace('234', '0') : phoneNo;
		}
		return phoneNo;
	}

	canShowError() {
		return this.input?.isShowError() && this.validationError;
	}

	initializeInput() {
		return new PhoneNumberInput(null, null, true);
	}

	addPhoneNumberPrefixClass() {
		if (this.validationError) {
			return 'kyc-provision-primer-mobile-prefix-container-invalid';
		}
		return this.isPhoneNumberOnFocus ? 'kyc-provision-primer-mobile-prefix-container-valid' : '';
	}

	setPhoneNumberOnFocus(isPhoneNumber) {
		this.isPhoneNumberOnFocus = isPhoneNumber;
	}

	onFocus() {
		this.setPhoneNumberOnFocus(true);
		document.getElementById(this.id)?.focus();
	}

	onChangeInput($event) {
		let input: string = $event?.target?.value;
		input = input.replace(/ /g, '');
    input = StringHelper.numbersOnly(input);
		$event.target.value = input;
		$event.target.defaultValue = input;
		const inputValue = this.input?.prefix ? input : this.complimentNigeriaNumber(input);
		this.onInputChange(inputValue);
	}

	complimentNigeriaNumber(phoneNo: string) {
		try {
			const isZero = phoneNo?.charAt(0) === '0';
			return isZero ? phoneNo : `0${phoneNo}`;
		} catch (e) {
			logger.error('error ', e);
		}
	}

	onInputChange(input) {
		this.input.setInput(input);
		this.validInput = this.input.validate();
		this.validInput ? this.setValidInputAfterValidation() : this.setErrorAfterValidation();
		this.emitInput.emit(this.input);
	}

	setValidInputAfterValidation() {
		this.placeHolder = ' ';
		this.validationError = false;
	}

	setErrorAfterValidation() {
		this.placeHolder = this.input.getPlaceHolder() || this.input.getLabel();
		this.validationError = true;
	}
}
